/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import { HashLink as Link } from "react-router-hash-link";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_Abfindung-Kosten_700px.jpg";
import { gaSet } from "../../../services/cookieService";
import Typography from "@mui/material/Typography";
import { Link as MuiLink, Paper } from "@mui/material";

const GuidebookSettlementCosts = () => {
  const title = "Ratgeber - Welche Kosten kommen auf mich zu? | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Wir erklären Ihnen, welche Kosten auf Sie zukommen, wenn Sie nicht
        rechtsschutzversichert sind und von einer Rechtsschutzversicherung übernommen wird."
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan slogan={"Welche Kosten kommen auf mich zu?"} backgroundImagePath={backgroundTeaser} height={300} headingColor={"#333333"} />
        <TextContainer>
          <p>
            Das Wichtigste vorab: Auch ohne Rechtsschutzversicherung haben Sie bei Legalbird kein Kostenrisiko! Damit Sie umfassend informiert sind, haben wir
            für Sie kurz zusammengefasst, welche Kosten im Normalfall auf Sie zukommen würden.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Welche Kosten entstehen bei einer Kündigungsschutzklage?
          </Typography>
          <p>
            Im Normalfall gilt: Wenn Sie gegen eine Kündigung vorgehen wollen, müssen Sie immer Anwaltskosten zahlen - egal ob für Sie ein Erfolg erzielt wird,
            oder nicht. Die Kosten können schnell mehrere Tausend Euro betragen und sind fixe Kosten, die immer anfallen. Für das Erstellen der Klage und das
            Führen des Verfahrens muss die sogenannte <strong>Verfahrensgebühr</strong> gezahlt werden. Hinzu kommt die <strong>Terminsgebühr</strong>, die
            anfällt, da Ihr Anwalt Sie im Gütetermin und gegebenenfalls bei weiteren Terminen vor Gericht vertritt. Wenn es im Laufe des Verfahrens zu einer
            Einigung kommt, fällt zudem die sogenannte <strong>Einigungsgebühr</strong> an.
          </p>
          <p>
            Wenn Sie sich nicht im Gütetermin mit Ihrem Arbeitgeber einigen können und es zu einem Kammertermin kommt, müssen{" "}
            <strong>zudem noch zusätzlich Gerichtskosten</strong> gezahlt werden. Details zum Ablauf bei einer Kündigungsschutzklage finden Sie{" "}
            <MuiLink component={Link} sx={guidebookContentStyle.link} to={"/ratgeber/arbeitsrecht/ablauf"}>
              hier
            </MuiLink>
            .
          </p>
          <HighlightBox headline={"Bei Legalbird haben Sie auch ohne Rechtsschutzversicherung keine Sorgen!"}>
            <p>
              Uns ist es wichtig, dass Sie nur dann etwas zahlen müssen, wenn für Sie ein Erfolg erzielt wurde. Daher übernimmt ein privater
              Prozesskostenfinanzierer für Sie die Anwalts- und Gerichtskosten und Sie haben auch ohne Rechtsschutzversicherung kein Kostenrisiko. Nur wenn Ihr
              Fall erfolgreich abgeschlossen wurde, zahlen Sie eine zuvor vereinbarte Provision an den Prozessfinanzierer, in der Regel ein Drittel der
              Abfindungssumme, die wir für Sie verhandelt haben.
            </p>
          </HighlightBox>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Übernimmt meine Rechtsschutzversicherung die Kosten?
          </Typography>
          <p>
            Wenn Sie im voraus eine Rechtsschutzversicherung für Arbeitsrecht abgeschlossen haben, übernimmt die Versicherung in der Regel immer die gesamten
            Kosten für den Prozess. Die Klage wäre somit für Sie kostenlos. Wenn Sie einen Selbstbehalt vereinbart haben, dann übernimmt Legalbird diesen für
            Sie!
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Kündigung unverbindlich prüfen lassen
          </Typography>
          <p>
            Sie sind sich nicht sicher, ob ein Prozess sich für Sie lohnt, oder wie gut die Chancen für einen Gewinn der Klage stehen? Starten Sie jetzt ganz
            einfach mit dem ersten Schritt und lassen Sie Ihre Kündigung unverbindlich prüfen! Wir kümmern uns persönlich um Sie und besprechen die
            Möglichkeiten und Chancen mit Ihnen.
          </p>
          <DoubleButton
            buttonText={"Kündigung unverbindlich prüfen"}
            buttonLink={"/servicewelt"}
            backText={"Zurück zum Ratgeber"}
            backLink={"/ratgeber/arbeitsrecht"}
          />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookSettlementCosts;
